import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const CTASection = ({ 
  title, 
  description, 
  actionLabel, 
  actionTo,
  accentColor = '#3b82f6'
}) => {
  return (
    <section className="py-20 bg-[#0a1628]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div 
          className="bg-gradient-to-br from-[#162544] to-[#1e3a5f] rounded-3xl p-12 border"
          style={{ borderColor: `${accentColor}20` }}
        >
          <h2 className="text-3xl font-bold text-[#f1f5f9] mb-4">
            {title}
          </h2>
          <p className="text-[#94a3b8] mb-8 max-w-xl mx-auto">
            {description}
          </p>
          <Link to={actionTo}>
            <Button className="btn-primary text-white font-medium px-10 py-6 text-lg rounded-xl">
              {actionLabel}
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
